/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SponsorDelete = {
    properties: {
        sponsor_id: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
